import { c as _c } from "react/compiler-runtime";
import type { MessageListOutput } from '@/orpc/client';
import { useTranslations } from 'next-intl';
import { toast } from 'sonner';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useDeleteMessage } from '@/hooks/queries/message.query';
type DeleteButtonProps = {
  message: MessageListOutput['messages'][number];
};
export function DeleteButton(props) {
  const $ = _c(42);
  const {
    message
  } = props;
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = () => {
      toast.success(t("success.message-deleted"), {
        testId: "guestbook-message-deleted-toast"
      });
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    mutate: deleteMessage,
    isPending: isDeleting
  } = useDeleteMessage(t0);
  let t1;
  if ($[2] !== deleteMessage || $[3] !== isDeleting) {
    t1 = function handleDeleteMessage(id) {
      if (isDeleting) {
        return;
      }
      deleteMessage({
        id
      });
    };
    $[2] = deleteMessage;
    $[3] = isDeleting;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleDeleteMessage = t1;
  let t2;
  if ($[5] !== t) {
    t2 = t("common.delete");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isDeleting || $[8] !== t2) {
    t3 = <AlertDialogTrigger render={<Button variant="destructive" disabled={isDeleting} aria-disabled={isDeleting} data-testid="guestbook-delete-button">{t2}</Button>} />;
    $[7] = isDeleting;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = t("common.dialogs.delete-comment.title");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <AlertDialogTitle>{t4}</AlertDialogTitle>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("common.dialogs.delete-comment.description");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <AlertDialogDescription>{t6}</AlertDialogDescription>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <AlertDialogHeader>{t5}{t7}</AlertDialogHeader>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t("common.cancel");
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <AlertDialogCancel>{t9}</AlertDialogCancel>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== handleDeleteMessage || $[26] !== message.id) {
    t11 = () => {
      handleDeleteMessage(message.id);
    };
    $[25] = handleDeleteMessage;
    $[26] = message.id;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t) {
    t12 = t("common.delete");
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = <AlertDialogAction onClick={t11} variant="destructive" data-testid="guestbook-dialog-delete-button">{t12}</AlertDialogAction>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t13) {
    t14 = <AlertDialogFooter>{t10}{t13}</AlertDialogFooter>;
    $[33] = t10;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t14 || $[37] !== t8) {
    t15 = <AlertDialogContent data-testid="guestbook-dialog">{t8}{t14}</AlertDialogContent>;
    $[36] = t14;
    $[37] = t8;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t15 || $[40] !== t3) {
    t16 = <div className="mt-4 flex justify-end"><AlertDialog>{t3}{t15}</AlertDialog></div>;
    $[39] = t15;
    $[40] = t3;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  return t16;
}